import React, { useState, useEffect } from "react";
import ReactJson from "react-json-view";
import axios from "axios";
import { api } from "../../revampCRUD/axios.config";

const AttendeeAppAnalytics = ({ eventInfo }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Replace with your API endpoint
        const fetchData = async () => {
            try {
                const response = await axios.get(`${api.apiUrl}/event/${eventInfo?.event_id}/att-app/analytics`);
                setData(response.data);
            } catch (err) {
                setError("Failed to fetch data.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div style={styles.container}>
            {loading && <p>Loading...</p>}
            {error && <p style={styles.error}>{error}</p>}
            {data && <ReactJson src={data} theme="monokai" collapsed={false} />}
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "Arial, sans-serif",
        margin: "50px auto",
        maxWidth: "100%",
    },
    header: {
        color: "#333",
    },
    error: {
        color: "red",
    },
};

export default AttendeeAppAnalytics;
